import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

const Modal = ({
  open,
  handleClose,
  handleOk,
  title,
  content,
  textButtonOk,
  hasDialogAction,
  maxWidth,
}: any) => (
  <Dialog
    open={open}
    onClose={handleClose}
    maxWidth={maxWidth}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
    <DialogContent>{content}</DialogContent>
    {hasDialogAction && (
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          Close
        </Button>
        {textButtonOk && (
          <Button onClick={handleOk} color="primary" autoFocus>
            {textButtonOk}
          </Button>
        )}
      </DialogActions>
    )}
  </Dialog>
);

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleOk: PropTypes.func,
  title: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  textButtonOk: PropTypes.string.isRequired,
  hasDialogAction: PropTypes.bool,
  maxWidth: PropTypes.string,
};

Modal.defaultProps = {
  handleOk: () => {},
  hasDialogAction: true,
  maxWidth: "xl",
};

export default Modal;
